import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function useIsUp() {
  const theme = useTheme();

  const upXs = useMediaQuery(theme.breakpoints.up('xs'));
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const upLg = useMediaQuery(theme.breakpoints.up('lg'));
  const upXl = useMediaQuery(theme.breakpoints.up('xl'));

  return {
    xs: upXs,
    sm: upSm,
    md: upMd,
    lg: upLg,
    xl: upXl,
  };
}

function useIsDown() {
  const theme = useTheme();

  const downXs = useMediaQuery(theme.breakpoints.down('xs'));
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));
  const downMd = useMediaQuery(theme.breakpoints.down('md'));
  const downLg = useMediaQuery(theme.breakpoints.down('lg'));
  const downXl = useMediaQuery(theme.breakpoints.down('xl'));

  return {
    xs: downXs,
    sm: downSm,
    md: downMd,
    lg: downLg,
    xl: downXl,
  };
}


function useBreakpoint() {
  switch (true) {
    case window.screen.width < 1920 && window.screen.width >= 1280:
      return 'lg';
    case window.screen.width < 1280 && window.screen.width >= 960:
      return 'md';
    case window.screen.width < 960 && window.screen.width >= 600:
      return 'sm';
    case window.screen.width < 600 && window.screen.width >= 0:
      return 'xs';
    default:
      return 'xl';
  }
}

function useIsWidthBetween(start, end) {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between(start, end));
}

const withMediaQuery = (params = {}) => WrappedComponent => props => {
  const parameter = { start: 'xs', end: 'lg', ...params };
  const isUp = useIsUp();
  const isDown = useIsDown();
  const breakpoint = useBreakpoint();
  const isBetween = useIsWidthBetween(parameter.start, parameter.end);
  return (
    <WrappedComponent {...props}
      isUp={isUp}
      isDown={isDown}
      isBetween={isBetween}
      breakpoint={breakpoint} />
  );
};
export default withMediaQuery;
